import { render } from "./LernView.vue?vue&type=template&id=61606d2e"
import script from "./LernView.vue?vue&type=script&lang=js"
export * from "./LernView.vue?vue&type=script&lang=js"

import "./LernView.vue?vue&type=style&index=0&id=61606d2e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__